<div style="display: flex; align-items: center; justify-content: center; height: 50vh">
    <div style="display: flex; flex-direction: column; align-items: center">
        <p style="width: 250px">To transfer your client to another coach/advisor please enter their email used to login on IRIS and select Transfer.</p>
        <input nz-input type="email" [(ngModel)]="email">
        <button nz-button nzType="primary" (click)="transfer()" style="margin-top: 10px">Transfer</button>
    </div>
</div>
